export default "__VITE_ASSET__BdHY0sJv__"